/* ==========================================================================
   LALTERNATIVA - "foto intera": niente ritaglio sugli still life
   Caricato da snippets/las-global-inline.liquid su tutte le pagine.
   Si porta dietro il proprio CSS (vedi REGOLE piu' sotto), quindi non
   dipende da nessun altro file. Restano attive, e non danno fastidio, le
   vecchie regole per formato in assets/las-home-mobile.css e in
   snippets/las-pdp-inline.liquid: agiscono sulle foto caricate subito,
   prima ancora che parta questo script, quindi fanno da rete immediata.

   PERCHE' ESISTE QUESTO FILE
   Le scatole delle foto sono 2:3 con object-fit:cover. Va benissimo finche'
   la foto e' anch'essa 2:3. Le foto piu' LARGHE di 2:3 invece perdono
   larghezza: l'11% su un 3:4, il 17% su un 4:5. Su una modella in piedi non
   si nota, ai lati c'e' fondo bianco. Su uno still life si' eccome: punta,
   tacco e manico arrivano vicino al bordo dello scatto e finiscono tagliati.

   PRIMA C'ERA SOLO IL CSS, E NON BASTAVA
   La versione precedente riconosceva il formato dagli attributi width e
   height che il tema stampa sulle <img> (533x711, 533x666...). Nell'HTML
   che arriva dal server quei numeri sono giusti - controllato: 71 foto
   533x754, 25 foto 533x711, 4 foto 533x666. Ma il componente
   <responsive-image> del tema, sulle foto caricate in differita (quelle
   che entrano mentre si scorre), RISCRIVE width e height con la misura
   della scatola: 286x430. A quel punto il selettore CSS non aggancia piu'
   niente e quelle foto restano ritagliate.
   Risultato: le prime file della collezione erano a posto e quelle sotto
   no. E' il difetto che si vedeva su Impulsion, Noisette, Ecume, Peniche,
   Pinceau.

   COME LAVORA ADESSO
   Non si fida piu' degli attributi: guarda naturalWidth e naturalHeight,
   cioe' le proporzioni VERE del file, che nessuno puo' riscrivere. Se la
   foto e' piu' larga della soglia, le mette addosso la classe
   las-foto-intera e il CSS passa a object-fit:contain.

   LA SOGLIA (0,72) E PERCHE' NON E' 0,667
     0,563  calzature storiche, fondo GRIGIO ... sotto soglia -> cover
     0,667  2:3, il formato bersaglio .......... sotto soglia -> cover (non taglia)
     0,707  abbigliamento 1414x2000 ............ sotto soglia -> cover (-5,6%, invisibile)
     0,750  calzature e cinture nuove .......... SOPRA -> contain
     0,800  borse nuove ........................ SOPRA -> contain
   Le storiche 0,563 devono restare su cover: con contain lascerebbero due
   fasce bianche ai lati e, avendo il fondo grigio, si vedrebbe un riquadro
   grigio incorniciato di bianco. Gia' provato il 21 settembre, annullato.
   L'abbigliamento resta su cover perche' 5,6% di larghezza su fondo bianco
   non si vede e perche' non ha senso toccare 71 card per niente.

   SI SPEGNE DA SOLA
   Quando una foto viene ricaricata in 2:3 il suo rapporto diventa 0,667,
   sta sotto soglia e la classe non le viene piu' messa. Quando tutto il
   catalogo sara' 2:3 questo file e le regole CSS collegate si potranno
   cancellare senza che cambi niente.

   SE UN DOMANI SERVE DISATTIVARLA
   Togli il tag <script> da snippets/las-global-inline.liquid: si torna al
   comportamento del tema, non si rompe nulla.
   ========================================================================== */
(function () {
  'use strict';

  var SOGLIA = 0.72;
  var CLASSE = 'las-foto-intera';
  var DOVE = '.product-card__image img, .f-product__media img';

  /* Il foglio di stile se lo porta dietro lo script, invece di stare in
     assets/las-home-mobile.css. Cosi' la correzione e' tutta in un file
     solo: per spegnerla basta togliere il tag <script> e non restano
     regole orfane in giro per il tema.
     I selettori sono volutamente lunghi: devono battere in specificita'
     la regola della galleria in snippets/las-pdp-inline.liquid
       .f-product__media-list--grid-2-cols .f-product__media img
     che e' object-fit:cover!important. A parita' di peso vincerebbe
     l'ultima caricata, e l'ordine di caricamento non e' garantito. */
  var REGOLE =
    '.product-card__image img.' + CLASSE + '{object-fit:contain!important}' +
    '.f-product__media-list--grid-2-cols .f-product__media img.' + CLASSE + '{object-fit:contain!important}' +
    '.f-product__media-list .f-product__media img.' + CLASSE + '{object-fit:contain!important}';

  function stile() {
    if (document.getElementById('las-foto-intera-css')) return;
    var testa = document.head || document.documentElement;
    if (!testa) return;
    var s = document.createElement('style');
    s.id = 'las-foto-intera-css';
    s.textContent = REGOLE;
    testa.appendChild(s);
  }
  stile();

  function valuta(img) {
    if (!img || img.tagName !== 'IMG') return;

    var w = img.naturalWidth;
    var h = img.naturalHeight;
    // Foto non ancora scaricata: non si sa nulla, si ripassa al suo "load".
    if (!w || !h) return;

    if (!img.closest('.product-card__image, .f-product__media')) return;

    if (w / h >= SOGLIA) {
      img.classList.add(CLASSE);
    } else {
      img.classList.remove(CLASSE);
    }
  }

  function passaTutte() {
    var lista = document.querySelectorAll(DOVE);
    for (var i = 0; i < lista.length; i++) valuta(lista[i]);
  }

  // 1) Le foto che finiscono di scaricarsi. "load" non risale il DOM, va
  //    intercettato in fase di cattura sul documento.
  document.addEventListener('load', function (e) { valuta(e.target); }, true);

  // 2) Le foto gia' presenti quando parte lo script, e un secondo giro a
  //    pagina completa per sicurezza.
  passaTutte();
  document.addEventListener('DOMContentLoaded', passaTutte);
  window.addEventListener('load', passaTutte);

  // 3) Le card aggiunte dopo: scorrimento infinito, filtri di collezione,
  //    anteprima rapida, carosello "ti potrebbe piacere".
  if (window.MutationObserver) {
    new MutationObserver(function (modifiche) {
      for (var i = 0; i < modifiche.length; i++) {
        var nuovi = modifiche[i].addedNodes;
        for (var j = 0; j < nuovi.length; j++) {
          var n = nuovi[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.tagName === 'IMG') {
            valuta(n);
          } else if (n.querySelectorAll) {
            var dentro = n.querySelectorAll('img');
            for (var k = 0; k < dentro.length; k++) valuta(dentro[k]);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
